import type { FC, ReactNode } from 'react';
import type React from 'react';
import Tooltip, { type TooltipProps } from '@components/Tooltip';
import { Icon } from '@mdi/react';
import type { IconProps } from '@mdi/react/dist/IconProps';
import clsx from 'clsx';

import IconMdi from './IconMdi';

export type TooltipedIconProps = IconProps & {
  containerClassName?: string;
  onClick?: React.HTMLAttributes<HTMLDivElement>['onClick'];
  dataTestId?: string;
  subIcon?: string;
  content?: ReactNode;
} & Pick<TooltipProps, 'maxWidth' | 'placement'>;

export const TooltipedIcon: FC<TooltipedIconProps> = ({
  containerClassName,
  dataTestId,
  onClick,
  placement = 'right',
  content,
  size = 0.7,
  subIcon,
  maxWidth,
  ...props
}) => (
  <Tooltip content={content} placement={placement} disabled={!content} maxWidth={maxWidth}>
    <div onClick={onClick} data-testid={dataTestId} className={clsx('relative my-auto', containerClassName)}>
      <Icon {...props} size={size} />
      {subIcon && (
        <IconMdi path={subIcon} size={0.5} className={clsx(props.className, 'absolute -right-2 -bottom-2')} />
      )}
    </div>
  </Tooltip>
);
